export default "__VITE_ASSET__BslyFSW1__"